import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';

import { CommonService } from '../../../shared/services/common.service';
import { BaseFormGroup } from '../../../shared/form-input-components/base-form-group';
import { arrayNotEmptyValidator } from '../../../shared/validators/array-not-empty-validator';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent extends BaseFormGroup implements OnInit, OnDestroy {

  @Input() formDetails: FormGroup;
  @Input() tripFormDetails: FormGroup;
  @Input() bookingEditConfig: any;
  @Input() reqRiderDropdown: any;
  @Input() referenceBooking: any;
  @Input() miscelleneousConfig: any;
  @Input() configComplete: any;

  @Output() notAllGuestEmitter: EventEmitter<boolean>= new EventEmitter();


  public requester: any;
  public requesterConfig: any;
  public riderConfig: any;
  public requesterFormGroup: any;
  public isNoRiderErrorVisible: boolean;
  public startRiderConfig: any;
  isLoading = false;
  public cancelCutOffDetails: any;
  public editCutOffDetails: any;

  private destroy$ = new Subject();
  riders: any[];

  constructor(private commonService: CommonService, private authService: AuthService) {
    super();
  }

  ngOnInit() {
    this.isLoading = true;
    this.authService.getServerTime({buid: this.authService.user.buId}).subscribe((res) => {
      this.authService.serverTime = res;
      this.isLoading = false;
      this.requesterConfig = this.commonService.getConfigForElementKey(this.configComplete, 'Requester Form');
      this.riderConfig = this.commonService.getConfigForElementKey(this.configComplete, 'Rider Form');
      this.setupForm();

  });

    if (this.miscelleneousConfig?.enableCityWiseCreationCutOff){
    this.commonService.fetchCityCutoff().subscribe((response: any) => {
      this.commonService.cityCuttoffObj.next(response.bookingTypeConfig);
    });
  }
  else{
     this.commonService.fetchCutoff().subscribe((response: any) => {
    this.commonService.cuttoffObj.next(response.bookingTypeConfig);
  });
  }

    this.getCancelCutOff();
    this.getEditCutOff();
  }

  setupForm() {
    if (!Object.keys(this.formDetails.controls).length) {
      this.formDetails.addControl('requester', new FormGroup({}));
      this.formDetails.addControl('riders', new FormArray([], arrayNotEmptyValidator) );
    }
    
    if(this.miscelleneousConfig?.verifyEngagementCode){
      this.formDetails.get('riders').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value)=>{
        if(value && Array.isArray(value)){
          this.riders = value;
          let isAllGuest = true;
          value.some((rider)=>{
            if(rider['riderTypeId']?.toLowerCase() !== 'guest'){
              isAllGuest = false;
              return true;  
            }
          })
          this.notAllGuestEmitter.emit(isAllGuest);
        }
      })
    }
  }
  getCancelCutOff() {
    this.commonService.fetchCancelConfig().subscribe((response) => {
      this.cancelCutOffDetails = response;
      this.commonService.cancelcuttoffObj.next(String(response.cutOffMins));
    });
  }

  getEditCutOff() {
    this.commonService.fetchEditConfig().subscribe((response) => {
      this.editCutOffDetails = response;
      this.commonService.editcuttoffObj.next(String(response.cutOffMins));
    });
  }
  updateRequestorInRiderTable = () => {
    this.requester = this.getFormControl('requester').getRawValue();
  }

  showNoRiderError = () => {
    this.isNoRiderErrorVisible = true;
  }

  hideNoRiderError = () => {
    this.isNoRiderErrorVisible = false;
  }

  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

}
